import React from 'react';
import { connect } from 'react-redux';
import { AppBar, Box, LinearProgress, Theme, Toolbar, Typography } from '@mui/material';

import devTools from '@paragon/dev-tools';
import { getSpinnersToDisplay } from '@paragon/task-spinner';
import { ThemedLogo } from '@paragon/themes';

import markupLogoUrl from '../../../resources/markup.png';
import { RootState } from '../../store';
import HeaderTools from './HeaderTools';

type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;

const Header = (props: Props) => {
  const { jobId, stampedBy } = props;

  const sealedBy = (
    <Typography variant="subtitle1" sx={{ color: '#fff' }}>
      {`Job ${jobId} - ${stampedBy ? `Sealed by ${stampedBy}` : 'Not Sealed'}`}
    </Typography>
  );

  let spinner = null;
  if (props.spinnerMessages.size > 0) {
    spinner = (
      <div>
        <LinearProgress color="secondary" />
      </div>
    );
  }

  return (
    <div>
      <AppBar
        position="absolute"
        sx={{
          zIndex: (theme: Theme) => theme.zIndex.drawer + 1,
          borderBottom: 'solid 3px #f4d166',
          backgroundImage: 'none',
        }}
      >
        <Toolbar>
          <ThemedLogo clientLogoUrl={markupLogoUrl} clientName="Paragon Markup" />
          <Box sx={{ flex: 1, ml: 1 }}>
            <Typography sx={{ color: '#fff' }} variant="h1">
              PARAGON MARKUP
            </Typography>
            {sealedBy}
          </Box>
          <HeaderTools />
          {devTools.renderDevToolsButton()}
        </Toolbar>
        {spinner}
      </AppBar>
    </div>
  );
};

function mapStateToProps(state: RootState) {
  let stampedBy = '';

  const userWhoStampedJob = state.users.userData[state.job.stampedByEmail!];
  if (userWhoStampedJob != null) {
    stampedBy = `${userWhoStampedJob.firstName} ${userWhoStampedJob.lastName}`;
  }

  const { jobId } = state.job;

  return {
    spinnerMessages: getSpinnersToDisplay(state),
    stampedBy,
    jobId,
  };
}

export default connect(mapStateToProps)(Header);
